:host {
  position: relative;
  width: 100%;
  height: auto;
  /* margin-right: 50px;
  transform-origin: center center;
  transform: scale(1);
  transition: transform 0.5s;
  flex-shrink: 0;
  scroll-snap-align: center;
  scroll-snap-stop: always;
  overflow: hidden;
  outline: none;
  display: block; */

  @include slotted-margins("*:not([slot])");
}
